export const buttonVariantTemplate = {
  primary:
    'bg-gradient-to-r from-[#c4a34a] via-[#f2e6af] to-[#5f8d45] text-[#223f1e] border border-[#cbb26a] shadow-[0_8px_18px_rgba(196,163,74,0.28)] hover:brightness-105',
  ghost:
    'bg-white text-[#2f6d17] border border-[#9ad17a] hover:bg-[#f6ffe9]',
  dark:
    'bg-gradient-to-r from-[#43306e] to-[#5e4a8f] text-white border border-[#7a66ab] hover:brightness-110'
}

export const buttonSizeTemplate = {
  md: 'rounded-xl px-4 py-2 text-sm',
  lg: 'rounded-xl px-5 py-3 text-base'
}
